/* eslint-disable @typescript-eslint/no-require-imports */
import CustomPlatform from "$src/core/utils/platform/platform";

import type { ScreenOrientation } from "./types";

export default CustomPlatform.select<() => ScreenOrientation | null>({
  native: () => require("./screen-orientation").default,
  tv: () => null,
  web: () => null,
  default: () => null,
})();
